module.exports = __webpack_public_path__ + "static/weeks123_4-30681b2fe1acfe3771b1af5e370ef802.jpg";